import anim from '~/assets/icons/anim.svg';
import arrowRight from '~/assets/icons/arrow_right.svg';
import bonnet from '~/assets/icons/bonnet_2.svg';
import camhack from '~/assets/icons/camhack.svg';
import cross from '~/assets/icons/cross.svg';
import exit from '~/assets/icons/exit_2.svg';
import fov from '~/assets/icons/fov.svg';
import gasoline from '~/assets/icons/gasoline.svg';
import gpsRemove from '~/assets/icons/gps_remove.svg';
import gun from '~/assets/icons/gun.svg';
import inventoryCar from '~/assets/icons/inventory_car.svg';
import key from '~/assets/icons/key.svg';
import lights from '~/assets/icons/lights_2.svg';
import lock from '~/assets/icons/lock.svg';
import passenger from '~/assets/icons/passenger_2.svg';
import pts from '~/assets/icons/pts.svg';
import race from '~/assets/icons/race_2.svg';
import refresh from '~/assets/icons/refresh.svg';
import repair from '~/assets/icons/repair.svg';
import seatbelt from '~/assets/icons/seatbelt.svg';
import trade from '~/assets/icons/trade.svg';
import trunk from '~/assets/icons/trunk_2.svg';
import { RadialMenuIcon } from '~/shared';

const radialIcons: Record<RadialMenuIcon, string> = {
	[RadialMenuIcon.ShowPhotoMode]: camhack,
	[RadialMenuIcon.DespawnVehicle]: cross,
	[RadialMenuIcon.RepairVehicle]: repair,
	[RadialMenuIcon.FlipVehicle]: refresh,
	[RadialMenuIcon.ToggleLights]: lights,
	[RadialMenuIcon.ToggleEngine]: key,
	[RadialMenuIcon.ToggleLock]: lock,
	[RadialMenuIcon.ToggleTrunkLock]: trunk,
	[RadialMenuIcon.ShowVehiclePassport]: pts,
	[RadialMenuIcon.Exit]: exit,
	[RadialMenuIcon.Animate]: anim,
	[RadialMenuIcon.Race]: race,
	[RadialMenuIcon.Gun]: gun,
	[RadialMenuIcon.Bonnet]: bonnet,
	[RadialMenuIcon.FOV]: fov,
	[RadialMenuIcon.GPSRemove]: gpsRemove,
	[RadialMenuIcon.InventoryCar]: inventoryCar,
	[RadialMenuIcon.ToggleSeatbelt]: seatbelt,
	[RadialMenuIcon.VehicleOccupantsActions]: passenger,
	[RadialMenuIcon.Refuel]: gasoline,
	[RadialMenuIcon.EjectOccupant]: exit,
	[RadialMenuIcon.Exchange]: trade,
	[RadialMenuIcon.Next]: arrowRight,
};

const zoneMap: Record<
	number,
	Record<number, { start: number; end: number }>
> = {
	2: {
		0: { start: 90, end: 270 }, // левый блок
		1: { start: 270, end: 90 }, // правый блок
	},
	4: {
		0: { start: 150, end: 210 }, // левый блок
		1: { start: 210, end: 330 }, // верхний блок
		2: { start: 330, end: 30 }, // правый блок
		3: { start: 30, end: 150 }, // нижний блок
	},
	6: {
		0: { start: 174, end: 186 }, // левый блок (12° зона)
		1: { start: 186, end: 270 }, // верх-лево
		2: { start: 270, end: 354 }, // верх-право
		3: { start: 354, end: 6 }, // правый блок (12° зона)
		4: { start: 6, end: 90 }, // низ-право
		5: { start: 90, end: 174 }, // низ-лево
	},
	8: {
		0: { start: 174, end: 186 }, // левый блок (12° зона)
		1: { start: 186, end: 225 }, // верх-лево
		2: { start: 225, end: 315 }, // верх
		3: { start: 315, end: 354 }, // верх-право
		4: { start: 354, end: 6 }, // правый блок (12° зона)
		5: { start: 6, end: 45 }, // низ-право
		6: { start: 45, end: 135 }, // низ
		7: { start: 135, end: 174 }, // низ-лево
	},
};

export interface IAnimationCoords {
	translateX: number;
	translateY: number;
}

export const animationCoordsMap: Record<number, IAnimationCoords[]> = {
	2: [
		{ translateX: -260, translateY: -25 }, // Левая позиция к центру
		{ translateX: 0, translateY: 25 }, // Правая позиция к центру
	],
	4: [
		{ translateX: -260, translateY: -25 }, // Левая позиция к центру
		{ translateX: -130, translateY: -50 }, // Верхняя позиция к центру
		{ translateX: 0, translateY: -25 }, // Правая позиция к центру
		{ translateX: -130, translateY: 0 }, // Нижняя позиция к центру
	],
	6: [
		{ translateX: -260, translateY: -25 }, // Левая позиция к центру
		{ translateX: -260, translateY: -25 }, // Верх-лево
		{ translateX: 0, translateY: -25 }, // Верх-право
		{ translateX: 0, translateY: -25 }, // Правая позиция к центру
		{ translateX: 0, translateY: 0 }, // Низ-право
		{ translateX: -260, translateY: 0 }, // Низ-лево
	],
	8: [
		{ translateX: -260, translateY: -25 }, // Левая позиция к центру
		{ translateX: -260, translateY: -25 }, // Верх-лево
		{ translateX: -130, translateY: -50 }, // Верхняя позиция к центру
		{ translateX: 0, translateY: -25 }, // Верх-право
		{ translateX: 0, translateY: -25 }, // Правая позиция к центру
		{ translateX: 0, translateY: 0 }, // Низ-право
		{ translateX: -130, translateY: 0 }, // Нижняя позиция к центру
		{ translateX: -260, translateY: 0 }, // Низ-лево
	],
};

export const radialAnim = {
	stepDelayMs: 40, // задержка между элементами
	transformMs: 100, // длительность transform
	transformOpacityMs: 30, // длительность opacity
	bufferMs: 30, // запас после последнего элемента
	domTickMs: 16, // пауза между фазами для применения DOM
};

export { radialIcons, zoneMap };
